<template>
    <modal
        :saveAction="saveAction"
        :deleteAction="data._id ? data.can_delete ? deleteAction : false : false"
        :title="$t(title)"
        :id="id"
        :actionButtons="!hideForm"
        size="full"
        :closeButton="hideForm"
        @shown="shown"
        @hidden="hidden"
    >
        <div class="row" style="height:70vh; overflow-y:auto">
            <div class="col-12" v-if="tab=='general'">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>{{$t('Product name')}}*</label>
                            <b-form-input
                                :autofocus="true"
                                v-model.trim="data.label"
                                type="text"
                                :state="validation('label')"
                                :placeholder="$t('Ex.:Medical glove')"
                            ></b-form-input>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label>{{$t('Barcode')}}</label>
                                    <b-form-input
                                        v-model.trim="data.barcode"
                                        type="text"
                                        :state="validation('barcode')"
                                        :placeholder="$t('Ex.:12345678')"
                                    ></b-form-input>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label>{{$t('SKU')}}</label>
                                    <b-form-input
                                        v-model.trim="data.sku"
                                        type="text"
                                        :state="validation('sku')"
                                        :placeholder="$t('Ex.:AC12345')"
                                    ></b-form-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <label>{{$t('Category')}}*</label>
                            <div class="input-group">
                                <b-form-select
                                    v-model.trim="data.categoryId"
                                    type="text"
                                    :options="categories"
                                    :state="validation('categoryId')"
                                ></b-form-select>
                                <div class="input-group-append">
                                    <button
                                        @click="openModal({id:'categoryFormModal', model:{}})"
                                        type="button"
                                        class="btn btn-outline-secondary"
                                    >
                                        <i style="line-height: 0" class="fe fe-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label>{{$t('Brand')}}</label>
                            <div class="input-group">
                                <b-form-select
                                    v-model.trim="data.brandId"
                                    type="text"
                                    :options="brands"
                                    :state="validation('brandId')"
                                ></b-form-select>
                                <div class="input-group-append">
                                    <button
                                        @click="openModal({id:'brandFormModal', model:{}})"
                                        type="button"
                                        class="btn btn-outline-secondary"
                                    >
                                        <i style="line-height: 0" class="fe fe-plus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label>{{$t('Description')}}</label>
                            <b-form-textarea
                                v-model.trim="data.description"
                                :state="validation('description')"
                                :placeholder="''"
                            ></b-form-textarea>
                        </div>
                    </div>

                    <div class="col-6">
                        <label>{{$t('Image')}}</label>
                        <div class="row">
                            <div class="col-auto" v-if="data.avatar_id">
                                <avatar
                                    :src="data.avatar ? data.avatar.preview : null"
                                    size="avatar-xxl"
                                    type="rounded"
                                ></avatar>
                            </div>
                            <div class="col">
                                <button
                                    class="btn btn-white"
                                    type="button"
                                    @click="openModal({id:'mediaModal', multiple:true})"
                                >
                                    <span class="fe fe-image"></span>
                                    {{$t('Set photo')}}
                                </button>
                                <br />
                                <button
                                    class="btn btn-info mt-2"
                                    type="button"
                                    @click="clearImage"
                                    v-if="data.avatar_id"
                                >
                                    <span class="fe fe-trash"></span>
                                    {{$t('Remove image')}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-3">
                        <b-form-group :label="$t('Measurement')">
                            <b-form-select
                                v-model.trim="data.measurement"
                                type="text"
                                :options="measurements"
                                :state="validation('measurement')"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <label>{{$t('Required minimum at store')}} ({{ $t(data.measurement) }})</label>
                            <b-form-input
                                v-model.trim="data.minimum"
                                type="text"
                                :state="validation('minimum')"
                                :placeholder="$t('Ex.:100')"
                            ></b-form-input>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <label>{{$t('Per serving')}} ({{ $t(data.measurement) }})</label>
                            <b-form-input v-model.trim="data.perServing" type="text" :placeholder="$t('Ex.:100')"></b-form-input>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label>
                                {{$t('In waiting list')}}
                                <b-form-checkbox v-model.trim="data.inWaitlist"></b-form-checkbox>
                            </label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <label>
                                {{$t('In buy list')}}
                                <b-form-checkbox v-model.trim="data.toBuy"></b-form-checkbox>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <media-modal id="mediaModal" category="products" :action="useImage"></media-modal>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Avatar from '@/components/Avatar.vue'
import MediaModal from '@/components/MediaModal.vue'
import MoneyField from '@/components/MoneyField.vue'
import CustomSwitch from "@/components/CustomSwitch.vue";
import DatePicker from '@/components/DatePicker';
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'

export default {
    name: 'product-form-modal',
    props: ['id', 'data'],
    mixins: [modalMixins],
    components: {
        Modal,
        Avatar,
        MoneyField,
        MediaModal,
        DatePicker,
        CustomSwitch,
    },
    data() {
        return {
            loading: false,
            hideForm: false,
            title: 'Product',
            tab: 'general',
            supply: {},
            supplyForm: false,
            measurements: [
                { value: 'ml', text: this.$t('Ml') },
                { value: 'mg', text: this.$t('Mg') },
                { value: 'g', text: this.$t('G') },
                { value: 'sm', text: this.$t('Sm') },
                { value: 'units', text: this.$t('Units') },
                { value: 'pack', text: this.$t('Pack') },

            ],
            errors: {},

        }
    },
    computed: {
        ...mapState('service', { areServicesLoading: 'isFindPending' }),
        ...mapGetters('service', { findServicesInStore: 'find' }),
        ...mapGetters('brands', { findBrandsInStore: 'find' }),
        ...mapGetters('categories', { findCategoriesInStore: 'find' }),
        ...mapGetters('suppliers', { findSuppliersInStore: 'find' }),

        categories() {
            return this.findCategoriesInStore().data.map(item => {
                return { value: item._id, text: item.label }
            });
        },
        brands() {
            return this.findBrandsInStore().data.map(item => {
                return { value: item._id, text: item.label }
            });
        },
        suppliers() {
            return this.findSuppliersInStore().data.map(item => {
                return { value: item._id, text: item.label }
            });
        },
        services() {
            const data = this.findServicesInStore(this.params).data;
            const result = [];
            data.forEach(item => {
                result.push({ text: item.label, value: item._id });
            })
            return result;
        }
    },
    mounted() {

        this.$root.$on('bv::hide::modal', (modal) => {
            this.hideForm = false;
            // this.data = {};
        })
    },

    methods: {
        ...mapActions('products', ['create', 'patch', 'remove']),

        clearImage() {
            this.data.avatar_id = null;
            this.data.avatar = {};
        },
        useImage(image) {
            console.log('image', image);
            this.data.avatar_id = image._id;
            this.data.avatar = image;
        },
        deleteAction() {
            this.remove(this.data._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Item has been removed')
                });
            });
        },
        saveAction() {
            let promise, successMessage;

            if (this.data._id) {
                promise = this.patch([this.data._id, this.data]);
                successMessage = 'Product has been saved';
            } else {
                promise = this.create(this.data);
                successMessage = 'Product has been created';
            }

            promise.then(data => {
                this.$root.$emit('bv::hide::modal', this.id);
                this.$toasted.global.success({
                    message: this.$t(successMessage)
                });
            });

            promise.catch(err => {
                this.errors = err.errors;
                //console.log(this.errors);
            });


        },
        shown() {
            this.errors = {};
            if (!this.data.notifications) {
                this.data.notifications = [];
            }
        },
        hidden() {
            this.data = {};
        },

        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        }
    },

}
</script>
